export default {
  routes: [
    {
      name: 'configuration',
      path: '/development/configuration',
      component: () => import('./views/TheConfiguration.vue')
    },
  ]
}
